<script lang="ts">
  import IntegratedTooltipIcon from "@shared/svelte/Components/IntegratedTooltipIcon.svelte";
  import RequestItemTooltip from "@shared/svelte/Components/RequestableItems/RequestItemTooltip.svelte";
  import PriceWrapper from "@retailer/svelte/Shared/PriceWrapper.svelte";
  import ProductImage from "@shared/svelte/Components/ProductImage.svelte";
  import LoadingSpinner from "@shared/svelte/Components/LoadingSpinner.svelte";
  import { Text } from "@getprovi/craft-svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  import { bottleTopsEnglish } from "@shared/filters/bottle_tops_english";
  import { capitalize } from "lodash";
  import { sizeAndUnitsDisplay } from "@shared/services/product";
  import { productContainerDetailsShort } from "@shared/filters/product_container_details";

  export let inventoryId: number;

  let product;
  let productLine;
  let distributor;
  let inventory;

  $: caseInfo = productContainerDetailsShort(product);

  const load = async () => {
    try {
      const response = await HttpPromise({
        method: "GET",
        url: `/api/retailer/requested_items/${inventoryId}`,
      });
      product = response.product_summary;
      productLine = response.product_line_summary;
      distributor = response.distributor_summary;
      inventory = response.inventory_summary;
    } catch (error) {
      console.error(error, "error");
    }
  };
</script>

<style>
  hr {
    border: 0;
    border-top: 1px solid #eaeaea;
  }

  .info-container {
    max-width: 345px;
  }
</style>

{#await load()}
  <LoadingSpinner />
{:then}
  <div class="craft mb-24 border-b-4">
    <div class="flex flex-row gap-4 mb-16">
      <ProductImage
        product={productLine}
        width={72}
        height={72}
        fizz={true}
        className="cart-recommendations-product-image"
        usePlaceholderImage={true}
        extraAttrs={{ id: "product-card-image" }}
      />
      <div class="flex flex-col gap-0">
        <Text semibold>{productLine.name}</Text>

        <div class="flex flex-row gap-4">
          <div class="fizz-relative" style="top: 0.25rem">
            <IntegratedTooltipIcon
              {distributor}
              tooltipClasses="fizz-tooltip-bottom fizz-tooltip-left"
            />
          </div>
          <Text size="sm">{distributor.name}</Text>
        </div>
      </div>
    </div>

    <div class="flex flex-row gap-4 justify-between info-container">
      <div class="flex flex-col gap-4">
        <Text size="sm" semibold>
          {sizeAndUnitsDisplay(product)}
          {#if product.container_type == "bottle" && product.material}
            {capitalize(product.material)}
          {/if}
          {#if product.container_type == "bottle"}
            {capitalize(bottleTopsEnglish(product.bottle_tops))}
          {/if}
          {product.container_type}
        </Text>
        <Text size="sm">
          {caseInfo}
        </Text>

        <Text size="xs" color="disabled">
          {#if inventory.sku}
            SKU: {inventory.sku}
          {/if}</Text
        >
      </div>

      <div class="flex flex-col gap-4">
        <PriceWrapper
          inventoryId={inventory.id}
          productTypeId={productLine.product_type_id}
          showPricePerOunce={false}
        />
        <RequestItemTooltip bind:product bind:distributor tooltipPosition={"fizz-tooltip-right"} />
      </div>
    </div>
  </div>
  <hr class="mb-24" />
{/await}
